module.exports = __webpack_public_path__ + "static/media/patrol(25).4dc07d96.PNG";